import Store from "./Store";
export default Store;
export {default as Apollo} from "./Apollo";
export {default as History} from "./History";
export {default as Session} from "./Session";
export {default as StageStore} from "./StageStore";
// Create store globally
export const store = new Store();
